module.exports = __webpack_public_path__ + "static/media/before-you-start.69021be4.png";